import { render, staticRenderFns } from "./myTextArea.vue?vue&type=template&id=3ff93c44&"
import script from "./myTextArea.vue?vue&type=script&lang=ts&"
export * from "./myTextArea.vue?vue&type=script&lang=ts&"
import style0 from "./myTextArea.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports